import { NgModule } from '@angular/core';
import { ChevronRightComponent } from '~shared/svgs/chevron-right/chevron-right.component';

@NgModule({
  declarations: [
    ChevronRightComponent
  ],
  exports: [
    ChevronRightComponent
  ]
})
export class ChevronRightModule {}
